import createUsercryptApi from '@rhg/libs/api/create-usercrypt-api';
import useAuth from '@rhg/libs/auth0/use-auth';
import { queryKeys, useQuery } from '@rhg/libs/react-query';
import { useActiveCircle } from '../use-active-circle';

export function useCheckinEntriesByType(checkinTypeKey: string) {
    const { activeCircle: circle } = useActiveCircle();
    const { isAuthenticated, getAccessTokenSilently } = useAuth();

    const { data, ...otherProps } = useQuery({
        queryKey: [
            queryKeys.checkinEntries,
            circle?.recipient.id,
            checkinTypeKey,
        ],
        queryFn: async () => {
            const usercryptApi = createUsercryptApi(getAccessTokenSilently);

            const response =
                await usercryptApi.usercryptGetCheckinEntriesByType({
                    circleAuthorizationToken: circle!.authorizationJWT!,
                    recipientId: circle!.recipient.id,
                    checkinTypeKey,
                });

            return response.data;
        },
        enabled:
            isAuthenticated &&
            typeof circle?.authorizationJWT === 'string' &&
            typeof circle?.recipient.id === 'number',
    });

    return {
        ...data,
        ...otherProps,
    };
}
